<script>
    import { onMount } from "svelte";
    import { createEventDispatcher } from 'svelte';
    import { LocationStore, Authentication } from '../stores'
    
    const dispatch = createEventDispatcher();

    export let customer;

    let value;
    let shown = false;
    let authenthicationData = '';
    let locationsDropDown = [{ id: "0", text: "Loading ..." }];
    let locationsDropDownSelected;
    let orderableCheese = [];

    onMount(async function () {
        loadLocations();
    });

    async function loadLocations() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/location';

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        // Put the data in the store
        LocationStore.set(data);

        var arrayLength = data.length;
        if(arrayLength > 0) {
            locationsDropDown = [];
            for (var i = 0; i < arrayLength; i++) {
                locationsDropDown.push({id: data[i].id, text: data[i].name});
            }
        }
    }

    async function loadOrderableCheese() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/OrderableCheese/' + locationsDropDownSelected.id;

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();
        orderableCheese = data;

        var arrayLength = orderableCheese.length;
        for (var i = 0; i < arrayLength; i++) {
            orderableCheese[i].selected = (orderableCheese[i].customerId != 0);
            orderableCheese[i].selectable = (orderableCheese[i].customerId === 0 || orderableCheese[i].customerId === customer.id);
        }
    }

    export function show() {
        orderableCheese = [];
        locationsDropDownSelected = '';
        shown = true;
    }
    function hide() {
        shown = false;
    }

    let onChange = () => {};

    async function _onOkay() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let method = 'PUT';

        var updCheeseList = [];

        var arrayLength = orderableCheese.length;
    
        for (var i = 0; i < arrayLength; i++) {
            if(orderableCheese[i].selected === false && orderableCheese[i].customerId === customer.id) {
                orderableCheese[i].customerId = 0;
                updCheeseList.push(orderableCheese[i]);
            }
            if(orderableCheese[i].selected === true && orderableCheese[i].customerId === 0) {
                orderableCheese[i].customerId = customer.id;
                updCheeseList.push(orderableCheese[i]);
            }
        }

        const response = await fetch(
            'MYURL/CheeseList',
            {
                method: method,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
                body: JSON.stringify(
                    updCheeseList
                )
            }
        );
        const data = await response.json();

        dispatch('accepted', {
            
        });

        _onCancel();
    }
    
    function _onCancel() {
        hide();
    }

    function _showLocationPositions() {
        loadOrderableCheese();
    }
    
    function formatDate(date) {
        let the_date = new Date(date)
        let yyyy = the_date.getFullYear();
        let mm = the_date.getMonth() + 1; // Months start at 0!
        let dd = the_date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        return dd + '/' + mm + '/' + yyyy;
    }

    $: onChange(value)
</script>

<svelte:window on:keydown={(e) => {
    if(e.keyCode == 27) {
        hide();
    }
}} />
{#if shown}
    <div class="orderMgt">
        <div class="modal">
            <span class="close" on:click={() => hide()}>&times</span>

            <h2>Schrank und Käse auswählen</h2>
            <select class="textbox" bind:value={locationsDropDownSelected} on:change="{() => _showLocationPositions()}">
                {#each locationsDropDown as locationsDropDownItem}
                    <option value={locationsDropDownItem}>
                        {locationsDropDownItem.text}
                    </option>
                {/each}
            </select>
            <div class="wrapper">
                {#each orderableCheese as cheese}
                    <label>
                        <input type=checkbox bind:checked={cheese.selected} disabled={!cheese.selectable}>
                        <div class="selection"><b>Etage:</b>&nbsp;{cheese.locationLevel}&nbsp;<b>Pos.:</b>&nbsp;{cheese.locationLevelPosition}&nbsp;<b>{cheese.cheeseType_Name}</b></div>
                        {#if cheese.is_Matured == true}
                            <div class="spaceToNext"><b style='color:red;'>Erstellung:</b>&nbsp;{formatDate(cheese.creationDate)}</div>
                        {:else}
                            <div class="spaceToNext"><b>Erstellung:</b>&nbsp;{formatDate(cheese.creationDate)}</div>
                        {/if}
                    </label>
                {/each}
            </div>
            
            <div>
                <div class="buttons">
                    <button on:click={() => _onOkay()}>
                        Speichern
                    </button>
                    <button on:click={() => _onCancel()}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>
    .selection {
        display: inline-flex;
        justify-content: space-between;
    }

    .spaceToNext {
        margin-bottom: 10px;
    }

    .wrapper{
        padding:20px;
        max-height: 320px;
        overflow-y: scroll;
    }

    .textbox {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
    }

    .buttons {
        float: right;
    }

	.orderMgt {
	  background: rgb(0, 0, 0);
	  background: rgba(0, 0, 0, 0.6);
      position: fixed;
      width: 88%;
      height: 100%;
      top: 0;
      left: 0;

	  padding: 3rem 7.5rem;
	  display: flex;
	  flex-direction: column;
	}

    .modal {
        background-color: white;
        max-width: 80vw;
        padding: 1em;
        margin: -30px auto;
    }

    .close {
        cursor: pointer;
        float: right;
    }
    .close:hover {
        font-weight: bold;
    }
  
    @media only screen and (max-width: 767px) {
        .orderMgt {
            background: rgb(0, 0, 0);
            background: rgba(0, 0, 0, 0.6);
            position: fixed;
            width: 98%;
            height: 100%;
            top: 0;
            left: 0;

            padding: 3rem 1%;
            display: flex;
            flex-direction: column;
        }
        
        .textbox {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
        }
    }
</style>